import { Component } from "react";
import { loadOptionValues,
    loadPreferencekeys } from "../../actions/policy/policyActions";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

const mapStateToProps = (state) => {
  const { policyReducer } = { ...state };
  const selectedPolicy = policyReducer && policyReducer.selectedPolicy;
  return {
    policyDetails: state.policyReducer && state.policyReducer.selectedPolicy,
    MembershipNumber: selectedPolicy && selectedPolicy.MembershipNumber,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    loadOptionValues: (MembershipNumber) => dispatch(loadOptionValues(MembershipNumber)),
    loadPreferencekeys: () => dispatch(loadPreferencekeys()),
  };
};

class PreferenceRequired extends Component {
  constructor(props) {
    super(props);
    this.state = { isLoading: this.props.isPreferenceRequired };
  }

  async componentDidMount() {
    if(this.props.keys === null){
    if (this.props.isPreferenceRequired && this.props.policyDetails) {
        await this.props.loadPreferencekeys();
      await this.props
        .loadOptionValues(this.props.MembershipNumber);
    }
  }
  this.setState({
    isLoading: false
  });
  }

  render() {
    if (this.props.children && !this.state.isLoading) {
      return this.props.children;
    }
    return null;
  }
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(PreferenceRequired)
);
